/**
 * Google Drive Integration Module
 *
 * OAuth authentication, Drive API access, and state management for file selection
 *
 * @example
 * ```typescript
 * import {
 *   // Store
 *   useGoogleDriveStore,
 *   useGoogleDriveConnection,
 *   useGoogleDriveFiles,
 *   // Auth
 *   useGoogleAuth,
 *   getValidTokens,
 *   isGoogleConfigured,
 *   // API
 *   listFolders,
 *   listFiles,
 *   checkDriveConnection,
 *   // Types
 *   type GoogleDriveFile,
 *   type GoogleDriveFolder,
 * } from '@/lib/google-drive';
 *
 * // Check connection status via store
 * const { connectionState, connectedEmail, selectedFolder } = useGoogleDriveConnection();
 *
 * // Access files via store
 * const { files, folders, isLoading, hasMore } = useGoogleDriveFiles();
 *
 * // Check if OAuth is configured
 * if (isGoogleConfigured()) {
 *   // Use the OAuth hook to authenticate
 *   const { promptAsync, isConfigured } = useGoogleAuth();
 *
 *   // Use store actions for state management
 *   const store = useGoogleDriveStore();
 *   await store.checkConnection();
 *   await store.loadFilesAndFolders('root');
 * }
 * ```
 */

// Export types
export * from './types';

// Export configuration
export * from './config';

// Export auth functions
export * from './auth';

// Export Drive API functions
export * from './api';

// Export store and hooks
export * from './store';
